module.exports = __webpack_public_path__ + "static/media/SF-9-A.512a0946.mp3";